// extracted by mini-css-extract-plugin
export default {"fake-button":"_351PW","fakeButton":"_351PW"};